import React from "react";
import { GrayBoxContainer } from "components/Containers/Containers.styled";
import { Box, Typography } from "@material-ui/core";

interface BoxContainerProps {
    title?: string;
    spacing?: number;
    enableMargin?: boolean;
}

export const BoxContainer: React.FC<BoxContainerProps> = ({
    spacing = 2,
    enableMargin = true,
    title = "",
    children,
}) => {
    return (
        <GrayBoxContainer elevation={0} square spacing={spacing} enableMargin={enableMargin}>
            {title && (
                <Typography component="div" color="textSecondary" variant="h6">
                    <Box pl={0.5} mb={1} fontWeight="fontWeightBold">
                        {title}
                    </Box>
                </Typography>
            )}
            {children}
        </GrayBoxContainer>
    );
};
